// AI verse suggestion search. Given a free-text query (a feeling, a situation,
// a question) it returns relevant Bible passages with a short reason each —
// without interpreting Scripture or answering the question.
//
// The actual model call happens server-side (server/src/routes/verseSearch.js);
// this just calls our own backend, never a third-party API directly.

import { postJson } from './apiClient';

export async function searchVerses(query) {
  const data = await postJson('/api/verse-search', { query });
  return data.results;
}
